import {
  BigIcon,
  PrioritisationIcon,
  BulletsIcon,
  ChoicesIcon,
  DeprecatedIcon,
  DocumentIcon,
  FreeTextIcon,
  GoogleSlidesIcon,
  HeadingIcon,
  ImageIcon,
  InstructionsIcon,
  MiroIcon,
  NumberIcon,
  OpenEndedIcon,
  PinOnImageIcon,
  PowerpointIcon,
  QfaIcon,
  QuizChoicesIcon,
  QuizLeaderboardIcon,
  QuizOpenIcon,
  QuoteIcon,
  RankingIcon,
  RatingIcon,
  ScalesIcon,
  VideoIcon,
  WordcloudIcon,
  GuessTheNumberIcon,
  QuickFormIcon,
  ParagraphIcon,
} from './slide-types/index';

// old domain model
export const MODULE_ID_ICON_MAP = {
  '100-points': PrioritisationIcon,
  big: BigIcon,
  bullets: BulletsIcon,
  choices: ChoicesIcon,
  deprecated: DeprecatedIcon,
  document: DocumentIcon,
  'free-text': FreeTextIcon,
  'google-slides': GoogleSlidesIcon,
  heading: HeadingIcon,
  image: ImageIcon,
  instructions: InstructionsIcon,
  metadata: QuickFormIcon,
  miro: MiroIcon,
  number: NumberIcon,
  'numerical-question': GuessTheNumberIcon,
  open: OpenEndedIcon,
  paragraph: ParagraphIcon,
  'pin-on-image': PinOnImageIcon,
  powerpoint: PowerpointIcon,
  qfa: QfaIcon,
  'quiz-choices': QuizChoicesIcon,
  'quiz-leaderboard': QuizLeaderboardIcon,
  'quiz-open': QuizOpenIcon,
  quote: QuoteIcon,
  ranking: RankingIcon,
  rating: RatingIcon,
  scales: ScalesIcon,
  video: VideoIcon,
  wordcloud: WordcloudIcon,
} as const;

// new domain model
export const SLIDE_TYPE_ICON_MAP = {
  'free-text': FreeTextIcon,
  'google-slides': GoogleSlidesIcon,
  'guess-the-number': GuessTheNumberIcon,
  'multiple-choice': ChoicesIcon,
  'open-ended': OpenEndedIcon,
  'pin-on-image': PinOnImageIcon,
  'questions-from-audience': QfaIcon,
  'quick-form': QuickFormIcon,
  'quiz-choice': QuizChoicesIcon,
  'quiz-open': QuizOpenIcon,
  'word-cloud': WordcloudIcon,
  big: BigIcon,
  document: DocumentIcon,
  heading: HeadingIcon,
  image: ImageIcon,
  instructions: InstructionsIcon,
  leaderboard: QuizLeaderboardIcon,
  list: BulletsIcon,
  miro: MiroIcon,
  number: NumberIcon,
  paragraph: ParagraphIcon,
  powerpoint: PowerpointIcon,
  prioritization: PrioritisationIcon,
  quote: QuoteIcon,
  ranking: RankingIcon,
  rating: RatingIcon,
  scales: ScalesIcon,
  video: VideoIcon,
} as const;
